module.exports = __webpack_public_path__ + "static/media/menu.0869f855.svg";